import { Controller } from "@hotwired/stimulus"

// Adds/removes (tranche d'âge, EAN) rows in the KJ selection form and previews
// the resolved book title on blur of an EAN field.
export default class extends Controller {
  static targets = ["rows", "rowTemplate"]
  static values = { lookupUrl: String }

  addRow() {
    const fragment = this.rowTemplateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(fragment)
  }

  removeRow(event) {
    const row = event.target.closest("[data-jeunesse-selection-target='row']")
    if (!row) return

    const rows = this.rowsTarget.querySelectorAll("[data-jeunesse-selection-target='row']")
    if (rows.length > 1) {
      row.remove()
    } else {
      row.querySelectorAll("input").forEach((input) => (input.value = ""))
      this.#titleEl(row).textContent = ""
    }
  }

  async lookup(event) {
    const input = event.target
    const row = input.closest("[data-jeunesse-selection-target='row']")
    const titleEl = this.#titleEl(row)
    const isbn = input.value.trim()

    if (!isbn) {
      titleEl.textContent = ""
      return
    }

    // Cancel any in-flight lookup for this row so a slower response can't
    // overwrite the title of a newer query.
    if (row._lookupAbort) row._lookupAbort.abort()
    const aborter = new AbortController()
    row._lookupAbort = aborter

    try {
      const url = `${this.lookupUrlValue}?isbn=${encodeURIComponent(isbn)}`
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: aborter.signal })
      if (!response.ok) {
        titleEl.textContent = ""
        return
      }
      // admin/books#search returns [[id, isbn, title], ...] for an ilike match.
      const books = await response.json()
      const match = books.find((book) => book[1] === isbn)
      titleEl.textContent = match ? match[2] : "livre introuvable"
      titleEl.classList.toggle("text-danger", !match)
    } catch (error) {
      if (error.name !== "AbortError") titleEl.textContent = ""
    }
  }

  #titleEl(row) {
    return row.querySelector("[data-jeunesse-selection-target='title']")
  }
}
